import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import _get from 'lodash/get';
import { filterHandpickedArticleByWordCount } from 'containers/EditorList/utils';
import { makeSelectClientDetails } from 'containers/Main/selectors';
import {
  filterClientExclusiveResources,
  filterHandpickedResourceByCutoff,
} from 'containers/Resources/utils';
import useContentfulLocale from 'components/useContentfulLocale';
import useSiteConfigSelector from 'components/useSiteConfigSelector';
import { segregateClientLists } from '../helpers';
import getHomeClientList from '../../../services/getHomeClientList';

const filterResources = (lists, clientDetails, featuresConfig) =>
  lists.map(list => {
    let finalResources = filterClientExclusiveResources({
      resources: _get(list, 'fields.resources'),
      clientShortName: _get(clientDetails, 'shortName'),
      clientGroupShortName: _get(clientDetails, 'clientGroup.shortName'),
    })
      .filter(resource => _get(resource, 'fields.reviewStatus') === 'Accepted')
      .filter(resource =>
        filterHandpickedResourceByCutoff({
          resource,
          averageRatingCutoff: _get(clientDetails, 'averageRatingCutoff'),
          expertRatingCutoff: _get(clientDetails, 'expertRatingCutoff'),
          userRatingCutoff: _get(clientDetails, 'userRatingCutoff'),
        }),
      );

    if (_get(clientDetails, 'metadata.hideCostDescriptionResources')) {
      finalResources = finalResources.filter(
        resource =>
          !_get(
            clientDetails,
            'metadata.hideCostDescriptionResources',
          ).includes(_get(resource, 'fields.costDescription')),
      );
    }
    if (_get(clientDetails, 'metadata.filterShortArticles', false)) {
      finalResources = finalResources.filter(resource =>
        filterHandpickedArticleByWordCount({
          resource,
          featuresConfig,
          clientDetails,
        }),
      );
    }
    return {
      ...list,
      fields: {
        ...list.fields,
        resources: finalResources,
      },
    };
  });

export const useGetClientLists = clientId => {
  const ctfLocaleFilter = useContentfulLocale();
  const clientDetails = useSelector(makeSelectClientDetails());
  const [featuresConfig] = useSiteConfigSelector(['Features']);

  const { data, status } = useQuery(
    clientId && [
      'client-lists',
      clientId,
      _get(clientDetails, 'clientGroup.sys.id'),
      ctfLocaleFilter,
    ],
    getHomeClientList,
  );

  const { aboveFeatureList = [], belowFeatureList = [] } = data
    ? segregateClientLists(data)
    : {};

  const finalAboveFeatureList = filterResources(
    aboveFeatureList,
    clientDetails,
    featuresConfig,
  );
  const finalBelowFeatureList = filterResources(
    belowFeatureList,
    clientDetails,
    featuresConfig,
  );

  return {
    data: {
      aboveFeatureList: finalAboveFeatureList,
      belowFeatureList: finalBelowFeatureList,
    },
    status,
  };
};
